export enum SESSIONSTORAGE {
	RETRY_LAZY_REFRESHED = 'retry-lazy-refreshed',
	VIEW_PANEL_HANDOFF = 'view-panel-handoff',
}
